exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.assist-slicer[data-v-4daf0e0c] {\n  overflow: hidden;\n}\n.assist-slicer__hr[data-v-4daf0e0c] {\n    width: 100%;\n    margin: 10px 0;\n    border: 0;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/purang-shop-front-fun/buyer/src/components/Decors/AssistSlicer/AssistSlicerPreview.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;IACI,YAAY;IACZ,eAAe;IACf,UAAU;CACb","file":"AssistSlicerPreview.vue","sourcesContent":["\n.assist-slicer[data-v-4daf0e0c] {\n  overflow: hidden;\n}\n.assist-slicer__hr[data-v-4daf0e0c] {\n    width: 100%;\n    margin: 10px 0;\n    border: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4daf0e0c","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Decors/AssistSlicer/AssistSlicerPreview.vue
// module id = YzdK
// module chunks = 0